import { useState, useEffect, useCallback } from "react";

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

// Единицы измерения Bitrix (crm.measure.list), нужны для MEASURE_CODE строк сделки.
export const useMeasureOptions = () => {
    const [measureOptions, setMeasureOptions] = useState([]);

    useEffect(() => {
        const fetchMeasureOptions = async () => {
            try {
                const response = await fetch(`${PATH_TO_BACKEND}/api/measure-options`);
                const result = await response.json();
                if (result.status === "success") {
                    setMeasureOptions(result.measures);
                }
            } catch (error) {
                console.error("Ошибка загрузки единиц измерения:", error);
            }
        };
        fetchMeasureOptions();
    }, []);

    const getMeasureCode = useCallback((unitText) => {
        const found = measureOptions.find((m) => m.symbol === unitText);
        return found ? found.code : "796";
    }, [measureOptions]);

    return { getMeasureCode };
};
